module.exports = __webpack_public_path__ + "static/media/text_to_speach.22f27514.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/text_to_speach.png
// module id = 1459
// module chunks = 1